import React from "react";

const AuthorGuidelines = () => {
  return (
    <div className="flex flex-col gap-5 items-center justify-center min-h-screen">
      <div className="flex flex-col p-5 mt-32 bg-white rounded-xl max-w-[80%] min-w-[80%] shadow-2xl border-2 border-black">
        <b className="text-2xl text-center underline mb-5">
          {" "}
          The manuscript should be submitted according to format as follow
        </b>
        <b className="text-center text-2xl text-blue-400">
          Manuscript Preparation
        </b>
        <p>
          <br />
          <b>Article structure</b> <br />
          Follow this order when submitting manuscripts: Title, Authors,
          Affiliations, Abstract, Keywords, Main text, Acknowledgements,
          References, Appendix, Figure Captions and then Tables. Collate
          acknowledgments in a separate section at the end of the article and do
          not include them on the title page, as a footnote to the title or
          otherwise. <br /> <br />
          <b>Text Layout</b> <br />
          Use single line spacing and wide (3 cm) margins (Left justified.)
          Ensure that each new paragraph is clearly indicated. Present tables,
          figures and figure legends at the point they will appear in the
          manuscript. Number all pages consecutively; use 12 font sizes in Times
          New Roman fonts.
          <br /> <b>Subdivision – numbered sections</b> <br />
          Divide your article into clearly defined and numbered sections.
          Subsections should be numbered 1.1 (then 1.1.1, 1.1.2, …), 1.2, etc.
          (the abstract is not included in section numbering). Use this
          numbering also for internal cross-referencing: do not just refer to
          ‘the text’. Any subsection may be given a br/ief heading. Each heading
          should appear on its own separate line.
          <br /> <b>Introduction</b> <br />
          State the objectives of the work and provide an adequate background
          followed by literature survey in br/ief and summary of the results.
          <br /> <b>Material and methods</b> <br />
          Provide sufficient detail to allow the work to be reproduced. Methods
          already published should be indicated by a reference: only relevant
          modifications should be described.
          <br /> <b>Theory/calculation</b> <br />
          A Theory section should extend, not repeat, the background to the
          article already dealt with in the introduction section and lay the
          foundation for proposed work. In contrast, a Calculation section
          represents a practical development from a theoretical basis.
          <br /> <b>Results</b> <br />
          Results should be clear and concise.
          <br /> <b>Discussion</b> <br />
          This should explore the significance of the results of the work, not
          repeat them. A combined Results and Discussion section is often
          appropriate. Avoid extensive citations and discussion of published
          literature.
          <br /> <b>Conclusions</b> <br />
          The main conclusions of the study/work may be presented in a short
          concise manner in the conclusions section.
          <br />
          <br />{" "}
          <b className="block text-center text-2xl text-blue-400">
            Essential title page information
          </b>
          <br /> <b>Title</b> <br />
          Should be Concise and informative. Titles are often used in
          information-retrieval systems. Avoid abbr/eviations and formulae where
          possible.
          <br /> <b>Author names and affiliations</b> <br />
          Please clearly indicate the given name(s) and family name(s) of each
          author and check that all names are accurately spelled. Present the
          authors’ affiliation addresses (where the actual work was done) below
          the names. Indicate all affiliations with a lower-case superscript
          letter immediately after the author’s name and in front of the
          appropriate address. Provide the full postal address of each
          affiliation, including the country name and, if available, the e-mail
          address of each author.
          <br /> <b>Corresponding author </b> <br />
          Clearly indicate who will handle correspondence at all stages of
          refereeing and publication, also post-publication. Ensure that the
          e-mail address is given and that contact details are kept up to date
          by the corresponding author.
          <br /> <b>Present/permanent address</b> <br />
          If an author has moved since the work described in the article was
          done, or was visiting at the time, a ‘Present address’ (or ‘Permanent
          address’) may be indicated as a footnote to that author’s name. The
          address at which the author actually did the work must be retained as
          the main, affiliation address. Superscript Arabic numerals are used
          for such footnotes.
          <br /> <b>Abstract</b> <br />
          A self-contained abstract of 100 words, outlining in a single
          paragraph the aims, scope and conclusions of the paper must be
          supplied. The abstract should state br/iefly the purpose of the
          research, the principal results and major conclusions.
          <br /> <b>Keywords</b> <br />
          Immediately after the abstract, provide a maximum of 6 keywords and
          avoiding general and plural terms and multiple concepts (avoid, for
          example, ‘and’, ‘of’). These keywords will be used for indexing
          purposes.
          <br /> <b>Acknowledgements</b> <br />
          Collate acknowledgements in a separate section at the end of the
          article before the references and do not, therefore, include them on
          the title page, as a footnote to the title or otherwise. List here
          those individuals who provided help during the research (e.g.,
          providing language help, writing assistance or proof reading the
          article, etc.).
          <br /> <b>Formatting of funding sources</b> <br />
          List funding sources in this standard way to facilitate compliance to
          funder’s requirements:
          <br /> <b>Funding:</b> <br />
          This work was supported by the XXXXXXXX[grant numbers xxxx, yyyy] and
          the Bill &amp; XXXXXXXXX [grant number zzzz]. If no funding has been
          provided for the research, please include the following sentence: This
          research did not receive any specific grant from funding agencies in
          the public, commercial, or not-for-profit sectors.
          <br /> <b>Nomenclature and units</b> <br />
          Follow internationally accepted rules and conventions: use the
          international system of units (SI). If other quantities are mentioned,
          give their equivalent in SI.
          <br /> <b>Math formulae</b> <br />
          Please submit math equations as editable text and not as images.
          Present simple formulae in line with normal text where possible and
          use the solidus (/) instead of a horizontal line for small fractional
          terms, e.g., X/Y. In principle, variables are to be presented in
          italics. Powers of e are often more conveniently denoted by exp.
          Number consecutively any equations that have to be displayed
          separately from the text (if referred to explicitly in the text).
          <br /> <b>Artwork</b> <br />
          <br /> <b> Electronic artwork</b>
          <br />
          General points: Make sure you use uniform lettering and sizing of your
          original artwork. Embed the used fonts if the application provides
          that option. Aim to use the fonts Times New Roman. Number the
          illustrations according to their sequence in the text. Use a logical
          naming convention for your artwork files. Provide captions to
          illustrations separately. Size the illustrations close to the desired
          dimensions of the published version. Submit each illustration as a
          separate file.
          <br /> <b>Formats</b> <br />
          If your electronic artwork is created in a Microsoft Office
          application (Word, PowerPoint, Excel) then please supply ‘as is’ in
          the native document format. Regardless of the application used other
          than Microsoft Office, when your electronic artwork is finalized,
          please ‘Save as’ or convert the images to one of the following formats
          (note the resolution requirements for line drawings, halftones, and
          line/halftone combinations given below): EPS (or PDF): Vector
          drawings, embed all used fonts. TIFF (or JPEG): Color or grayscale
          photographs (halftones), keep to a minimum of 300 dpi. TIFF (or JPEG):
          Bitmapped (pure black &amp; white pixels) line drawings, keep to a
          minimum of 1000 dpi. TIFF (or JPEG): Combinations bitmapped
          line/half-tone (color or grayscale), keep to a minimum of 500 dpi.
          <br /> <b>Color artwork</b> <br />
          Please make sure that artwork files are in an acceptable format (TIFF
          (or JPEG), EPS (or PDF), or MS Office files) and with the correct
          resolution.
          <br /> <b>Figure captions</b> <br />
          Ensure that each illustration has a caption. Supply captions
          separately, not attached to the figure. A caption should comprise a
          br/ief title (not on the figure itself) and a description of the
          illustration. Keep text in the illustrations themselves to a minimum
          but explain all symbols and abbr/eviations used.
          <br /> <b>Tables</b> <br />
          Please submit tables as editable text and not as images. Tables can be
          placed either next to the relevant text in the article, or on separate
          page(s) at the end. Number tables consecutively in accordance with
          their appearance in the text and place any table notes below the table
          body. Be sparing in the use of tables and ensure that the data
          presented in them do not duplicate results described elsewhere in the
          article.
          <br />
          <br />
          <br />{" "}
          <b className="block text-2xl text-center text-blue-400">References</b>
          <br /> <b>Citation in text</b> <br />
          Please ensure that every reference cited in the text is also present
          in the reference list (and vice versa). The style of reference should
          be as follow:
          <br /> <b>Journal’s Reference</b> <br />
          Schott, D. H., Collins, R. N. &amp; Br/etscher, A. Secretory vesicle
          transport velocity in living cells depends on the myosin V lever arm
          length. J. Cell Biol. 156, 35-39 (2002).
          <br /> <b>Books</b> <br />
          Smith, J. Syntax of referencing in How to reference books (ed. Smith,
          S.) 180-181 (Macmillan, 2013).
          <br /> <b>Online material</b> <br />
          Manaster, J. Sloth squeak. Scientific American Blog Network
          http://blogs.scientificamerican.com/psi-vid/2014/04/09/sloth-squeak
          (2014). Conference Smith, A. K., Title of the paper, Conference’s
          name, Year In addition to the manuscript cover letter should be
          included.
        </p>
      </div>
    </div>
  );
};

export default AuthorGuidelines;
